import { useMedia } from '../../../hooks/useMedia';
import { MAX_MOBILE_WIDTH_IN_PX } from '../constants';
export function useIsMobileNavigation() {
    return useMedia({ maxWidth: MAX_MOBILE_WIDTH_IN_PX });
}
